import { softphoneGuideEn } from "./softphone.guide.en";

export const softphoneEn = {
  title: "Phone",
  intro:
    "The CRM launches the call in your softphone (the phone app on your computer). Set it up once with the guide below, then test it.",
  os_windows: "Windows — MicroSIP (recommended)",
  os_mac: "Mac — Zoiper 5 (recommended)",
  os_other:
    "Unrecognized system: pick your computer's tab. On another system, use a SIP softphone that handles tel: links.",
  guide: softphoneGuideEn,
  images: {
    "microsip-account": "MicroSIP: account screen",
    "microsip-links": "MicroSIP: tel: link handling",
    "windows-default-apps": "Windows: default apps",
    "zoiper-account": "Zoiper: account screen",
    "zoiper-tel-links": "Zoiper: tel: links",
    "zoiper-handler": "Zoiper: default app",
  },
  scheme: "Link type",
  scheme_microsip: "MicroSIP (dialpad:) — use this if Teams opens instead",
  sip_server: "SIP server",
  test: "Test the call",
  test_hint: "A test call to %{number} will open in your softphone.",
  confirm: "I heard the call",
  verified: "Softphone verified on %{date}",
  not_verified: "Softphone not verified",
  saved: "Preferences saved.",
  prefs_unavailable: "Could not load your preferences.",
  save_failed: "Could not save your preferences.",
  invalid_sip_server: "Invalid SIP server.",
  // GAVION granola-calls
  granola_title: "Granola notes during calls",
  granola_always: "A Granola note starts automatically on every dialer call.",
  granola_hint:
    "Granola must be installed and open on this computer. It will come to the front at each call.",
  granola_allow_hint:
    "The first time, the browser asks to open Granola: tick “Always allow”.",
  // GAVION inbound calls: the MicroSIP kit opens Granola
  granola_by_softphone: "Granola is opened by MicroSIP (Gavion kit)",
  granola_by_softphone_hint:
    "Tick if Gavion's MicroSIP kit is installed on this computer: it opens Granola on every call and the CRM no longer tries. The “Open Granola” button stays available.",
};
